import styled from "styled-components";

export const OverviewContainer = styled.div`
padding-top : 20%;
padding-left : 40%;
`;